var _path, _path2, _path3, _path4, _path5;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgHamburguer = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M30 35H10C7.23833 35 5 32.7617 5 30V15C5 9.47667 9.47667 5 15 5H25C30.5233 5 35 9.47667 35 15V30C35 32.7617 32.7617 35 30 35Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 13.3333C12.5871 13.3333 13.3333 12.5871 13.3333 11.6667C13.3333 10.7462 12.5871 10 11.6667 10C10.7462 10 10 10.7462 10 11.6667C10 12.5871 10.7462 13.3333 11.6667 13.3333Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 11.6666C17.5871 11.6666 18.3333 10.9205 18.3333 9.99998C18.3333 9.07951 17.5871 8.33331 16.6667 8.33331C15.7462 8.33331 15 9.07951 15 9.99998C15 10.9205 15.7462 11.6666 16.6667 11.6666Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9999 18.3333H4.99992C4.07825 18.3333 3.33325 17.5883 3.33325 16.6667C3.33325 15.745 4.07825 15 4.99992 15H34.9999C35.9216 15 36.6666 15.745 36.6666 16.6667C36.6666 17.5883 35.9216 18.3333 34.9999 18.3333Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9999 28.3334H4.99992C4.07992 28.3334 3.33325 27.5867 3.33325 26.6667V23.3334C3.33325 22.4134 4.07992 21.6667 4.99992 21.6667H17.1199C17.9183 21.6667 18.7066 21.8534 19.4199 22.21L23.4816 24.24C24.4216 24.71 25.5416 24.64 26.4149 24.0567L28.7049 22.53C29.5499 21.9667 30.5416 21.6667 31.5566 21.6667H34.9999C35.9199 21.6667 36.6666 22.4134 36.6666 23.3334V26.6667C36.6666 27.5867 35.9199 28.3334 34.9999 28.3334Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHamburguer, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/hamburguer.3c62cc07.svg";
export { ForwardRef as ReactComponent };